import { Tooltip } from 'react-tooltip';
import { handleDownloadPostQCData } from '../helpers';

export const renderPostQCButton = (
	indexCalcStatusRef,
	websocketStatusRef,
	postQCStatusRef,
	runPostQCIndexCalc,
	postQCData
) => {
	// postQCStatus 2  - disabled, post QC performed
	// postQCStatus 0 - enabled, perform post QC
	// postQCStatus 3 - error
	// postQCStatus 1 - loading

	// console.log(postQCResponse.length);
	// console.log(postQCStatusRef.current);

	if (
		indexCalcStatusRef.current === 0
		// ||(postQCStatusRef.current === 3 && postQCResponse.length < 2)
	) {
		return (
			<>
				<button
					style={{ width: '200px' }}
					className="btn interactButton"
					data-tooltip-id="performPostQCTT"
					onClick={(e) => runPostQCIndexCalc()}
				>
					Perform Post QC
				</button>

				<Tooltip id="performPostQCTTNotDone" place="bottom" effect="solid">
					Click to start the Post QC process
				</Tooltip>
			</>
		);
	} else if (
		websocketStatusRef.current === 1 ||
		indexCalcStatusRef.current === 1
	) {
		return (
			<>
				<button
					style={{ width: '200px' }}
					className="btn interactButtonDisabled"
					data-tooltip-id="performPostQCTTPerforming"
				>
					<span>Performing Post QC</span>
					<div className="animated-ellipsis ps-1">
						<span>.</span>
						<span>.</span>
					</div>
				</button>
				<Tooltip id="performPostQCTTPerforming" place="bottom" effect="solid">
					Performing index calculation ..
				</Tooltip>
			</>
		);
	} else if (postQCStatusRef.current === 2) {
		return (
			<>
				<button
					style={{ width: '200px' }}
					className="btn interactButtonDisabled"
					data-tooltip-id="performPostQCTTPerformed"
				>
					Performed Post QC <i className="ps-1 fa-solid fa-circle-check"></i>
				</button>
				<i
					className="fa-solid fa-file-arrow-down ms-2 interactIcon"
					data-tooltip-id="downloadPostQCDataIcon"
					onClick={() => handleDownloadPostQCData(postQCData)}
				></i>
				<Tooltip id="performPostQCTTPerformed" place="bottom" effect="solid">
					Completed index calculation
				</Tooltip>

				<Tooltip id="downloadPostQCDataIcon" place="bottom" effect="solid">
					Download post QC data
				</Tooltip>
			</>
		);
	} else if (
		postQCStatusRef.current === 3
		//&& postQCResponse.length >= 2
	) {
		return (
			<>
				<button
					style={{ width: '200px' }}
					className="btn interactButtonDisabled"
					data-tooltip-id="performPostQCTTError"
				>
					Error in Post QC{' '}
					<i className="ps-1 fa-solid fa-triangle-exclamation"></i>
				</button>
				<Tooltip id="performPostQCTTError" place="bottom" effect="solid">
					Error performing index calculation - see log
				</Tooltip>
			</>
		);
	} else {
		return (
			<button
				style={{ width: '200px' }}
				className="btn interactButtonDisabled"
				data-tooltip-id="performPostQCTT"
				disabled
			>
				Post QC
			</button>
		);
	}
};

export const renderUploadButton = (
	postQCStatusRef,
	uploadStatusRef,
	runUploadToDB,
	noPostQCData
) => {

	const postQCStatus = postQCStatusRef.current;
	const uploadStatus = uploadStatusRef.current;

	let buttonText = 'Upload to database';
	let tooltipText = 'Upload the performed calculation to the database';
	let buttonClass = 'btn interactButton';
	let isDisabled = false;
	let onClick;

	if (noPostQCData) {
		buttonClass = 'btn interactButtonDisabled';
		isDisabled = true;
		tooltipText = 'There was no data found.';
	} else if (postQCStatus !== 2) {
		buttonClass = 'btn interactButtonDisabled';
		isDisabled = true;
		tooltipText = 'Complete previous steps before performing upload.';
	} else if (uploadStatus === 1) {
		buttonText = (
			<>
				Uploading
				<div className="animated-ellipsis ps-1">
					<span>.</span>
					<span>.</span>
				</div>
			</>
		);
		buttonClass = 'btn interactButtonDisabled';
		isDisabled = true;
		tooltipText = 'Uploading the performed calculation to the database.';
	} else if (uploadStatus === 2) {
		buttonText = (
			<>
				Uploaded <i className="ps-1 fa-solid fa-circle-check" />
			</>
		);
		buttonClass = 'btn interactButtonDisabled';
		isDisabled = true;
		tooltipText = 'Successfully uploaded to the database.';
	} else if (uploadStatus === 3) {
		buttonText = (
			<>
				Error performing upload{' '}
				<i className="ps-1 fa-solid fa-triangle-exclamation" />
			</>
		);
		buttonClass = 'btn interactButtonDisabled';
		isDisabled = true;
		tooltipText = 'Cannot upload at this time. You can exit QC.';
	} else if (uploadStatus === 0) {
		onClick = runUploadToDB;
	}

	return (
		<>
			<button
				type="button"
				style={{ width: '200px' }}
				className={buttonClass}
				data-tooltip-id="uploadButtonTooltip"
				disabled={isDisabled}
				onClick={onClick}
			>
				{buttonText}
			</button>

			<Tooltip
				id="uploadButtonTooltip"
				place="bottom"
				effect="solid"
				style={{ zIndex: 9999 }}
			>
				{tooltipText}
			</Tooltip>
		</>
	);
};

export const renderFinishQCButton = (
	postQCStatusRef,
	finishQCEarly,
	finishQC,
	noPostQCData,
	postQCResponse,
	uploadStatusRef,
	uploadResponse
) => {
	
	if (postQCStatusRef.current === 3) {
		return (
			<>
				<button
					className="btn interactButton"
					data-tooltip-id="QCfinishedTT"
					style={{ width: '200px' }}
					onClick={(e) => finishQCEarly()}
				>
					Finish QC
					<i className="ps-2 fa-solid fa-circle-check"></i>
				</button>
				<Tooltip id="QCfinishedTT" place="bottom" effect="solid">
					There was an error - you can now exit QC.
				</Tooltip>
			</>
		);
	} else if (noPostQCData) {
		return (
			<>
				<button
					className="btn interactButton"
					data-tooltip-id="QCfinishedTT"
					style={{ width: '200px' }}
					onClick={(e) => finishQC()}
				>
					Finish QC
					<i className="ps-2 fa-solid fa-circle-check"></i>
				</button>
				<Tooltip id="QCfinishedTT" place="bottom" effect="solid">
					You can now finish QC and review the report
				</Tooltip>
			</>
		);
	} else if (
		postQCStatusRef.current === 0 ||
		(postQCStatusRef.current === 3 && postQCResponse.length < 2)
	) {
		return (
			<>
				<button
					className="btn interactButtonDisabled"
					data-tooltip-id="QCNotfinishedTT"
					style={{ width: '200px' }}
				>
					Finish QC
				</button>
				<Tooltip id="QCNotfinishedTT" place="bottom" effect="solid">
					Complete all steps of upload before completing QC
				</Tooltip>
			</>
		);
	} else if (uploadStatusRef.current === 2) {
		return (
			<>
				<button
					className="btn interactButton"
					data-tooltip-id="QCfinishedTT"
					style={{ width: '200px' }}
					onClick={(e) => finishQC()}
				>
					Finish QC
					<i className="ps-2 fa-solid fa-circle-check"></i>
				</button>
				<Tooltip id="QCfinishedTT" place="bottom" effect="solid">
					You can now finish QC and review the report
				</Tooltip>
			</>
		);
	} else if (
		(postQCStatusRef.current === 3 && postQCResponse.length >= 2) ||
		(uploadStatusRef.current === 3 && uploadResponse.length >= 2)
	) {
		return (
			<>
				<button
					className="btn interactButton"
					data-tooltip-id="QCfinishedTT"
					style={{ width: '200px' }}
					onClick={(e) => finishQCEarly()}
				>
					Finish QC
				</button>
				<Tooltip id="QCfinishedTT" place="bottom" effect="solid">
					You can now finish QC
				</Tooltip>
			</>
		);
	} else {
		return (
			<>
				<button
					className="btn interactButtonDisabled"
					data-tooltip-id="QCfinishedTT"
					style={{ width: '200px' }}
					disabled
				>
					Finish QC
				</button>
				<Tooltip id="QCfinishedTT" place="bottom" effect="solid">
					You can now finish QC
				</Tooltip>
			</>
		);
	}
};
